module.exports = __webpack_public_path__ + "static/media/logo131.9bd8da44.png";